import { useMemo } from 'react'

import { useFetchZervantCompany } from '@features/externalInvoicesSync/hooks/useFetchZervantCompany'
import { useUserOrganization } from '@modules-deprecated/app/organization'

export const useInvoiceEditorBaseCurrency = () => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const { company, isLoading: isZervantCompanyLoading } = useFetchZervantCompany()

  const isLoading = isOrganizationLoading || isZervantCompanyLoading

  const baseCurrency = useMemo(() => {
    if (organization?.baseCurrencyId === company?.currencyShortName) {
      return organization?.baseCurrencyId
    }
    // The case where organization base currency does not match company currency should not happen but if it
    // does happen, we return the company currency as a fallback.
    return company?.currencyShortName
  }, [company, organization])

  return { baseCurrency, isLoading }
}
